import * as Yup from "yup";
import i18n from "../i18n";

export const AccessGroupsSchema = Yup.object({
  accessGroupEn: Yup.string().required(
    i18n.language === "en"
      ? "Access Group Name (English) is required."
      : "اسم مجموعة الوصول (الإنجليزية) مطلوب."
  ),
  accessGroupAr: Yup.string().required(
    i18n.language === "en"
      ? "Access Group Name (Arabic) is required."
      : "اسم مجموعة الوصول (العربية) مطلوب."
  ),
  location: Yup.string().required(
    i18n.language === "en" ? "Location is required." : "الموقع مطلوب."
  ),
  building: Yup.string().required(
    i18n.language === "en" ? "Building is required." : "مطلوب بناء"
  ),
});
